import React, { useEffect, useState } from 'react'
import { Sparkles } from 'lucide-react'

interface CreditDisplayProps {
  credits: number
  className?: string
}

export const CreditDisplay: React.FC<CreditDisplayProps> = ({ credits, className = "" }) => {
  const [isDark, setIsDark] = useState(false)
  
  useEffect(() => {
    const checkDarkMode = () => {
      setIsDark(document.documentElement.classList.contains('dark'))
    }
    
    checkDarkMode()
    const observer = new MutationObserver(checkDarkMode)
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    
    return () => observer.disconnect()
  }, [])
  
  return (
    <div 
      className={`${className} transition-all hover:opacity-80`}
      style={{ 
        display: 'inline-flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        gap: '6px', 
        padding: '6px 12px', 
        borderRadius: '9999px',
        whiteSpace: 'nowrap',
        backgroundColor: isDark ? 'rgba(251, 191, 36, 0.2)' : 'rgba(251, 191, 36, 0.15)',
        border: `1px solid ${isDark ? 'rgba(251, 191, 36, 0.4)' : 'rgba(251, 191, 36, 0.3)'}`
      }}
    >
      <Sparkles size={14} style={{ color: isDark ? '#FBBF24' : '#D97706' }} />
      <span className="text-sm font-semibold" style={{ color: isDark ? '#FDE68A' : '#92400E' }}>
        {credits.toLocaleString()}
      </span>
    </div>
  )
}